// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"113":"544ce0fb","212":"8aecb95b","815":"f49fa2d6"}[chunkId] + ".chunk.css";
};